module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_foilSilverHover-c206492bb9ffa929637fb7fbe2de8d0a.jpg";